import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Typography, FormControl, TextField, Backdrop, CircularProgress, Dialog, DialogActions, DialogTitle, Modal, Box, Divider, CardActions, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, Alert } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { KeyboardArrowLeftRounded, DeleteRounded, CloseOutlined, EditOutlined, EditRounded, KeyboardDoubleArrowDownRounded, KeyboardDoubleArrowUpRounded, UndoRounded } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import ReactQuill from 'react-quill';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { formatDate } from '../../helpers/custom';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '45%',
    p: 4,
};

export interface IValues {
    comment: string,
    file: any
}

export interface IState {
    showLoader: boolean;
    ticket_id: string;
    ticket_details: any;
    communityHierarchyId: any;
    [key: string]: any;
    values: IValues[];
    submitSuccess: boolean;
    loading: boolean;
    comment: any;
    showDeleteMessageConfirmationDialog: boolean;
    messageToBeDeleted: any;
    showPausePickupHistoryModal: boolean;
    selectedMessage: any;
    showBagDistributionModal: boolean;
    allotedAgents: any;
    agents: any;
    overrideMinimumBagsReceived: boolean;
    bagCount: any;
    distributionType: any;
    date: any;
    aiDraftLoading: boolean;
    aiDraftHistory: string[];
    showCustomerData: boolean;
    customerBags: any[];
    customerPickups: any[];
    customerPayments: any[];
    customerTransactions: any[];
    customerTickets: any[];
    customerDataLoading: boolean;
    customerDataFetched: boolean;
    showPickupBags: boolean;
    pickupBags: any[];
    pickupBagsLoading: boolean;
    selectedPickup: any;
    activeTable: 'bags' | 'pickups' | 'payments' | 'transactions' | 'tickets';
    bagFilter: 'all' | 'active' | 'deleted';
    atBottom: boolean;
}

class TicketDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            ticket_id: this.props.match.params.id,
            ticket_details: {},
            values: [],
            loading: false,
            submitSuccess: false,
            comment: "",
            showDeleteMessageConfirmationDialog: false,
            messageToBeDeleted: null,
            showPausePickupHistoryModal: false,
            showEditModal: false,
            selectedMessage: null,
            showBagDistributionModal: false,
            communityHierarchyId: "",
            allotedAgents: '',
            agents: [],
            overrideMinimumBagsReceived: true,
            bagCount: 6,
            distributionType: '',
            date: null,
            aiDraftLoading: false,
            aiDraftHistory: [],
            showCustomerData: false,
            customerBags: [],
            customerPickups: [],
            customerPayments: [],
            customerTransactions: [],
            customerTickets: [],
            customerDataLoading: false,
            customerDataFetched: false,
            showPickupBags: false,
            pickupBags: [],
            pickupBagsLoading: false,
            selectedPickup: null,
            activeTable: 'bags',
            bagFilter: 'all',
            atBottom: false,
        }
    }

    public componentDidMount(): void {
        this.fetchTicketDetails();
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    public componentWillUnmount(): void {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll = () => {
        const atBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 100;
        if (atBottom !== this.state.atBottom) {
            this.setState({ atBottom });
        }
    }

    public fetchTicketDetails() {
        this.setState({ showLoader: true });
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds,
        }
        axios.get(`ticketDetails/${this.state.ticket_id}`, { params: body }).then((response: any) => {
            if (response.data.success) {
                const communityHierarchyId = response.data.data?.user?.community?.info?.hierarchy_id;
                this.setState({ ticket_details: response.data.data, communityHierarchyId, showLoader: false }, () => {
                    this.fetchAgents();
                    if (!this.state.customerDataFetched) this.fetchCustomerData();
                });
                // console.log(response.data.data);
            } else {
                // console.log("err");
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    private ticketReplyFormSubmission = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        let data = new FormData();
        data.append('ticket_id', this.state.ticket_id);
        data.append('comment', this.state.comment);
        if (this.state.files && this.state.files.length) {
            for (let i = 0; i < this.state.files.length; i++) {
                data.append('image[]', this.state.files[i]);
            }
        }
        axios.post('commentTicket', data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                // console.log("resp", response.data.data);
                this.setState({ comment: "" })
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchTicketDetails();
            } else {
                this.setState({ comment: "" })
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false, comment: "" });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    private fetchAIDraft = async () => {
        this.setState({ aiDraftLoading: true });
        try {
            const messages = this.state.ticket_details?.messages ?? [];
            const conversation = messages
                .map((m: any) => {
                    const label = m.user?.account_type === 'customer' ? 'customer' : 'admin';
                    const body = (m.message ?? '')
                        .replace(/<[^>]+>/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim();
                    const content = body || ((m.image?.length ?? 0) > 0 ? '[shared an attachment]' : '');
                    return content ? `[${label} - ${m.created_at}]: ${content}` : '';
                })
                .filter((line: string) => line)
                .join(' ');
            const res = await axios.post('fetchAIDraft', { text: this.state.comment, conversation });
            if (!res.data.success || !res.data.data?.draft) {
                throw new Error(res.data.msg || 'AI draft generation failed');
            }
            this.setState((prev) => ({
                comment: res.data.data.draft,
                aiDraftHistory: [...prev.aiDraftHistory, prev.comment]
            }));
        } catch (err: any) {
            toast.error(err?.response?.data?.msg || err?.message || 'AI Draft failed. Try again.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        } finally {
            this.setState({ aiDraftLoading: false });
        }
    }


    private undoAIDraft = () => {
        this.setState((prev) => {
            const history = [...prev.aiDraftHistory];
            const comment = history.pop() ?? prev.comment;
            return { comment, aiDraftHistory: history };
        });
    }

    private fetchCustomerData = () => {
        const userId = this.state.ticket_details?.user?.id;
        if (!userId) return;
        this.setState({ customerDataLoading: true });
        const hierarchies = this.props.user.selectedHierarchyIds;
        Promise.all([
            axios.get(`getCustomerDetails/` + userId, { params: { hierarchies } }),
            axios.post('filterPickups', { hierarchies, limit: 10, page: 1, user_id: userId, pickup_status: '' }, { headers: { "Content-Type": "application/json" } }),
            axios.post('listAllTickets', { hierarchies, type: '', customer_id: userId, page: 1, limit: 50 }, { headers: { "Content-Type": "application/json" } }),
        ]).then(([bagsRes, pickupsRes, ticketsRes]: any) => {
            const bags = (bagsRes.data?.data?.barcodes ?? []).slice().sort((a: any, b: any) => String(b.linked_date ?? '').localeCompare(String(a.linked_date ?? '')));
            const pickups = (pickupsRes.data?.data?.data ?? []).slice().sort((a: any, b: any) => String(b.pickup_date ?? '').localeCompare(String(a.pickup_date ?? '')));
            this.setState({
                customerBags: bags,
                customerPickups: pickups,
                customerTickets: ticketsRes.data?.data?.data ?? [],
                customerDataLoading: false,
                customerDataFetched: true,
            });
            const walletId = bagsRes.data?.data?.wallet_id;
            if (walletId) this.fetchWalletData(walletId);
        }).catch(() => {
            this.setState({ customerDataLoading: false });
            toast.error('Failed to load customer bags/pickups.', {
                position: "top-right", autoClose: 3000, hideProgressBar: true,
                closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored"
            });
        });
    }

    // Wallet payments + transactions
    private fetchWalletData = (walletId: any) => {
        const hierarchies = this.props.user.selectedHierarchyIds;
        const body = { hierarchies, limit: 50, page: 1, wallet_id: walletId };
        const opts = { headers: { "Content-Type": "application/json" } };
        Promise.all([
            axios.post('getCustomerWalletPayments', body, opts),
            axios.post('getCustomerWalletTransactions', body, opts),
        ]).then(([payRes, txRes]: any) => {
            this.setState({
                customerPayments: payRes.data?.data?.data ?? [],
                customerTransactions: txRes.data?.data?.data ?? [],
            });
        }).catch(() => {
            toast.error('Failed to load payments/transactions.', {
                position: "top-right", autoClose: 3000, hideProgressBar: true,
                closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored"
            });
        });
    }

    private openPickupBags = (pickup: any) => {
        this.setState({ showPickupBags: true, selectedPickup: pickup, pickupBagsLoading: true, pickupBags: [] });
        axios.get(`pickupDetails/` + pickup.id, { params: { hierarchies: this.props.user.selectedHierarchyIds } })
            .then((res: any) => {
                this.setState({ pickupBags: res.data?.data?.bags ?? [], pickupBagsLoading: false });
            }).catch(() => {
                this.setState({ pickupBagsLoading: false });
                toast.error('Failed to load bag details.', {
                    position: "top-right", autoClose: 3000, hideProgressBar: true,
                    closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored"
                });
            });
    }

    public updateComment = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        this.setState({ showEditModal: false });
        let data = new FormData();
        data.append('ticket_id', this.state.ticket_id);
        data.append('message_id', this.state.selectedMessage?.id);
        data.append('comment', this.state.selectedMessage?.message);

        console.log("here is updated", this.state.selectedMessage?.message);

        axios.post('updateCommentTicket', data, { headers: { "Content-Type": "multipart/form-data" } }).then((response: any) => {
            if (response.data.success) {
                // console.log("resp", response.data.data);
                this.setState({ comment: "" })
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchTicketDetails();
            } else {
                this.setState({ comment: "" })
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false, comment: "" });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public handleDeleteMessage() {
        let message: any = this.state.messageToBeDeleted;
        if (message) {
            this.setState({ showLoader: true });
            let payload: any = {
                ticket_id: message.ticket_id,
                message_id: message.id
            };
            axios.post(`deleteTicketMessage`, payload).then(response => {
                if (response.data.success) {
                    this.setState({ showDeleteMessageConfirmationDialog: false, showLoader: false, messageToBeDeleted: null }, () => this.fetchTicketDetails());
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                } else {
                    this.setState({ showDeleteMessageConfirmationDialog: false, showLoader: false, messageToBeDeleted: null });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showDeleteMessageConfirmationDialog: false, showLoader: false, messageToBeDeleted: null });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
    }

    public fetchAgents() {
        if (this.state.communityHierarchyId) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": [this.state.communityHierarchyId] }
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let agents: any = response.data.data;
                this.setState({ agents: agents });
            });
        }
    }

    // Parse the backend HTML summary blob into fields, lay them out as a compact column grid.
    private renderTicketSummary = (html: string) => {
        let fields: { label: string; html: string; wide: boolean; list: boolean }[] = [];
        try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const wide = ['issue', 'key facts', "what's blocking / why escalated", 'prior tickets'];
            let cur: any = null;
            Array.from(doc.body.children).forEach((n) => {
                const tag = n.tagName.toLowerCase();
                const b = n.querySelector('b');
                if (tag === 'details') {
                    const MAX_SHOWN = 5;
                    const ul: any = n.querySelector('ul');
                    const ticketLis: any[] = ul ? Array.from(ul.children).filter((li: any) => li.tagName === 'LI' && !(li.textContent || '').trim().toLowerCase().startsWith('pattern:')) : [];
                    const shownCount = Math.min(ticketLis.length, MAX_SHOWN);
                    ticketLis.slice(MAX_SHOWN).forEach((li: any) => li.remove());
                    const summaryEl: any = n.querySelector('summary');
                    if (summaryEl && shownCount) {
                        const badge = document.createElement('span');
                        badge.className = 'ticket-count-badge';
                        badge.textContent = `(${shownCount})`;
                        summaryEl.appendChild(badge);
                    }
                    // tag the Pattern <li>, split it into bullets, move to front so float:right sits it top-right
                    const pat: any = Array.from(n.querySelectorAll('li')).find((x: any) => (x.textContent || '').trim().toLowerCase().startsWith('pattern:'));
                    if (pat) {
                        pat.className = 'pattern-note';
                        const parts = (pat.textContent || '').replace(/^\s*pattern:\s*/i, '').split(';').map((s: string) => s.trim()).filter(Boolean);
                        pat.textContent = '';
                        const lbl = document.createElement('div');
                        lbl.className = 'pattern-label';
                        lbl.textContent = 'Pattern';
                        const pul = document.createElement('ul');
                        parts.forEach((p: string) => {
                            const li = document.createElement('li');
                            const escaped = p.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                            if (/^recurring\b/i.test(escaped.trim())) {
                                li.innerHTML = escaped.replace(/(\d+)\s*mo\b/gi, '$1 month');
                            } else {
                                const dates: string[] = [];
                                const withPlaceholders = escaped.replace(/\d{4}-\d{2}-\d{2}/g, (m: string) => { dates.push(m); return String.fromCharCode(0xE000 + dates.length - 1); });
                                const highlighted = withPlaceholders.replace(/\d+/g, (m: string) => `<span class="pattern-count">${m}</span>`);
                                li.innerHTML = highlighted.replace(/[\uE000-\uE0FF]/g, (m: string) => dates[m.charCodeAt(0) - 0xE000]);
                            }
                            pul.appendChild(li);
                        });
                        pat.appendChild(lbl);
                        pat.appendChild(pul);
                        if (ul && ul.firstChild) ul.insertBefore(pat, ul.firstChild);
                    }
                    fields.push({ label: '', html: n.outerHTML, wide: true, list: false });
                    cur = null;
                } else if (tag === 'p' && b && n.firstElementChild === b) {
                    const label = (b.textContent || '').replace(/:\s*$/, '').trim();
                    b.remove();
                    cur = { label, html: n.innerHTML.trim(), wide: wide.includes(label.toLowerCase()), list: false };
                    fields.push(cur);
                } else if (cur) {
                    cur.html += n.outerHTML;
                    if (tag === 'ul') { cur.list = true; cur.wide = true; }
                }
            });
        } catch { fields = []; }
        if (!fields.length) {
            return <Typography variant="body2" component="div" sx={{ fontSize: '0.85rem' }} dangerouslySetInnerHTML={{ __html: html }} />;
        }
        return (
            <Box sx={{
                mt: 0.75,
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
                gap: '14px 24px',
                fontSize: '0.95rem', lineHeight: 1.55, textAlign: 'left',
            }}>
                {fields.map((f, i) => (
                    <Box key={i} sx={{
                        // key-facts + prior-tickets (the list fields) span full width; the rest pair into 2 columns
                        gridColumn: f.list ? '1 / -1' : 'auto',
                        borderLeft: '3px solid', borderColor: 'divider', pl: 1.25,
                        '& p': { m: 0 },
                        // key-facts list → wrapped chips, no bullets (scannable, compact)
                        '& ul': { listStyle: 'none', display: 'flex', flexWrap: 'wrap', gap: '8px 10px', m: '5px 0 0', p: 0 },
                        '& li': { fontWeight: 500, bgcolor: 'action.hover', borderRadius: '6px', px: 1, py: '3px' },
                        '& details.prior-tickets ul': { display: 'block', listStyle: 'none', pl: 0, m: 0, overflow: 'hidden' },
                        '& details.prior-tickets li': { fontWeight: 400, bgcolor: 'transparent', borderRadius: 0, px: 0, py: 0 },
                        '& details.prior-tickets li:not(.pattern-note)': { display: 'list-item', listStyle: 'disc', ml: '18px' },
                        '& details.prior-tickets li.pattern-note': { float: 'right', width: '46%', listStyle: 'none', borderLeft: '2px solid', borderColor: 'divider', pl: '14px', mb: '4px', ml: 0 },
                        '& details.prior-tickets .pattern-label': { fontWeight: 700, mb: '3px' },
                        '& details.prior-tickets li.pattern-note ul': { listStyle: 'disc', pl: '18px', m: 0 },
                        '& details.prior-tickets li.pattern-note ul li': { display: 'list-item', ml: 0, mb: '3px' },
                        '& details.prior-tickets summary': { cursor: 'pointer', fontWeight: 700, listStyle: 'none', display: 'inline-flex', alignItems: 'center' },
                        '& details.prior-tickets summary::-webkit-details-marker': { display: 'none' },
                        '& details.prior-tickets summary::before': { content: '"\\25B8"', mr: '6px', fontSize: '1.1rem', fontWeight: 700, color: 'text.secondary' },
                        '& details.prior-tickets[open] summary::before': { content: '"\\25BE"' },
                        '& details.prior-tickets[open] summary': { color: 'primary.main' },
                        '& .ticket-count-badge': { ml: '6px', color: 'text.secondary', fontWeight: 700 },
                        '& .pattern-count': { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: '18px', px: '5px', mx: '2px', borderRadius: '8px', bgcolor: 'warning.light', color: 'warning.contrastText', fontSize: '0.88rem', fontWeight: 700 },
                    }}>
                        {f.label &&
                            <Typography component="div" sx={{ fontWeight: 700, color: 'text.secondary', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: 0.4, mb: 0.25 }}>
                                {f.label}
                            </Typography>
                        }
                        <Box component="div" dangerouslySetInnerHTML={{ __html: f.html }} />
                    </Box>
                ))}
            </Box>
        );
    }

    // Customer bags/pickups panel — always shown beside the reply box; table chosen via sub-toggle.
    private renderCustomerData = () => (
        <Box component="details" {...{ open: true } as any} sx={{
            textAlign: 'left',
            '& > summary': { cursor: 'pointer', listStyle: 'none', display: 'flex', alignItems: 'center', fontSize: '0.9rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4, color: 'text.secondary', mb: 0.75 },
            '& > summary::-webkit-details-marker': { display: 'none' },
            '& > summary::before': { content: '"\\25B8"', mr: '10px', fontSize: '1.2rem', color: 'text.secondary' },
            '&[open] > summary::before': { content: '"\\25BE"' },
        }}>
            <Box component="summary">Customer Details</Box>
            <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                <Button size="small" variant={this.state.activeTable === 'bags' ? 'contained' : 'outlined'} onClick={() => this.setState({ activeTable: 'bags' })}>
                    Bags ({this.state.customerBags.length})
                </Button>
                <Button size="small" variant={this.state.activeTable === 'pickups' ? 'contained' : 'outlined'} onClick={() => this.setState({ activeTable: 'pickups' })}>
                    Pickups ({this.state.customerPickups.length})
                </Button>
                <Button size="small" variant={this.state.activeTable === 'payments' ? 'contained' : 'outlined'} onClick={() => this.setState({ activeTable: 'payments' })}>
                    Payments ({this.state.customerPayments.length})
                </Button>
                <Button size="small" variant={this.state.activeTable === 'transactions' ? 'contained' : 'outlined'} onClick={() => this.setState({ activeTable: 'transactions' })}>
                    Transactions ({this.state.customerTransactions.length})
                </Button>
                <Button size="small" variant={this.state.activeTable === 'tickets' ? 'contained' : 'outlined'} onClick={() => this.setState({ activeTable: 'tickets' })}>
                    Tickets ({this.state.customerTickets.length})
                </Button>
            </Box>
            {this.state.activeTable === 'bags' && !this.state.customerDataLoading &&
                <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                    {(['all', 'active', 'deleted'] as const).map((f) => {
                        const n = f === 'all' ? this.state.customerBags.length
                            : f === 'active' ? this.state.customerBags.filter((b: any) => b.is_active).length
                                : this.state.customerBags.filter((b: any) => !b.is_active).length;
                        return (
                            <Button key={f} size="small" variant={this.state.bagFilter === f ? 'contained' : 'outlined'}
                                onClick={() => this.setState({ bagFilter: f })} sx={{ textTransform: 'capitalize' }}>
                                {f} ({n})
                            </Button>
                        );
                    })}
                </Box>
            }
            {this.state.customerDataLoading ?
                <Grid container justifyContent="center" className="p-3"><CircularProgress /></Grid>
                :
                <Grid container spacing={1}>
                    {this.state.activeTable === 'bags' &&
                        <Grid item md={12} xs={12} textAlign="left">
                            <DataGrid
                                autoHeight
                                density="compact"
                                rowHeight={46}
                                headerHeight={42}
                                disableSelectionOnClick
                                sx={{ fontSize: '0.95rem' }}
                                rows={this.state.customerBags
                                    .filter((b: any) => this.state.bagFilter === 'all' ? true : this.state.bagFilter === 'active' ? !!b.is_active : !b.is_active)
                                    .map((b: any, i: number) => ({ id: b.barcode ?? i, ...b }))}
                                columns={[
                                    { headerName: 'Barcode', field: 'barcode', flex: 1.2, minWidth: 110, resizable: true },
                                    { headerName: 'Date', field: 'linked_date', flex: 1, minWidth: 100, resizable: true },
                                    { headerName: 'Type', field: 'bag_type', flex: 0.8, minWidth: 80, resizable: true },
                                    {
                                        headerName: 'in_warehouse', field: 'reached_warehouse', flex: 1, minWidth: 110, resizable: true, renderCell: (params: any) => (
                                            <Typography className={params.row.reached_warehouse ? 'statusTextSuccess' : 'statusTextError'} component="span">
                                                {params.row.reached_warehouse ? 'Yes' : 'No'}
                                            </Typography>
                                        )
                                    },
                                    {
                                        headerName: 'Status', field: 'is_active', flex: 0.8, minWidth: 90, resizable: true, renderCell: (params: any) => (
                                            <Typography className={params.row.is_active ? 'statusTextSuccess' : 'statusTextError'} component="span">
                                                {params.row.is_active ? 'Active' : 'Deleted'}
                                            </Typography>
                                        )
                                    },
                                ]}
                                pageSize={6}
                                rowsPerPageOptions={[6]}
                            />
                        </Grid>
                    }
                    {this.state.activeTable === 'pickups' &&
                        <Grid item md={12} xs={12} textAlign="left">
                            <DataGrid
                                autoHeight
                                density="compact"
                                rowHeight={46}
                                headerHeight={42}
                                disableSelectionOnClick
                                rows={this.state.customerPickups}
                                onRowClick={(params: any) => this.openPickupBags(params.row)}
                                sx={{ fontSize: '0.95rem', '& .MuiDataGrid-row': { cursor: 'pointer' } }}
                                columns={[
                                    { headerName: 'Id', field: 'id', flex: 0.8, minWidth: 80, resizable: true },
                                    { headerName: 'Date', field: 'pickup_date', flex: 1, minWidth: 100, resizable: true },
                                    { headerName: 'Slot', field: 'pickup_slot', flex: 1, minWidth: 90, resizable: true },
                                    { headerName: 'Payment', field: 'payment_status', flex: 1, minWidth: 90, resizable: true },
                                    {
                                        headerName: 'Status', field: 'pickup_status', flex: 1, minWidth: 100, resizable: true, renderCell: (params: any) => (
                                            <Typography className={params.row.pickup_status == 'complete' ? 'statusTextSuccess' : 'statusTextError'} component="span">
                                                {params.row.pickup_status == 'complete' ? 'Complete' : 'Pending'}
                                            </Typography>
                                        )
                                    },
                                ]}
                                pageSize={6}
                                rowsPerPageOptions={[6]}
                            />
                            <Typography variant="caption" component="div" className="mt-1" style={{ color: '#888' }}>Click a pickup to view individual bag weights.</Typography>
                        </Grid>
                    }
                    {this.state.activeTable === 'payments' &&
                        <Grid item md={12} xs={12} textAlign="left">
                            <DataGrid
                                autoHeight
                                density="compact"
                                rowHeight={46}
                                headerHeight={42}
                                disableSelectionOnClick
                                sx={{ fontSize: '0.95rem' }}
                                rows={this.state.customerPayments.map((p: any, i: number) => ({ id: p.id ?? i, ...p }))}
                                columns={[
                                    { headerName: 'Id', field: 'id', flex: 0.7, minWidth: 70, resizable: true },
                                    { headerName: 'Type', field: 'type', flex: 1, minWidth: 110, resizable: true },
                                    { headerName: 'Title', field: 'title', flex: 1.4, minWidth: 140, resizable: true },
                                    { headerName: 'Amount', field: 'amount', type: 'number', flex: 0.8, minWidth: 90, resizable: true },
                                    { headerName: 'Updated At', field: 'updated_at', flex: 1.2, minWidth: 150, resizable: true },
                                ]}
                                pageSize={6}
                                rowsPerPageOptions={[6]}
                            />
                        </Grid>
                    }
                    {this.state.activeTable === 'transactions' &&
                        <Grid item md={12} xs={12} textAlign="left">
                            <DataGrid
                                autoHeight
                                density="compact"
                                rowHeight={46}
                                headerHeight={42}
                                disableSelectionOnClick
                                sx={{ fontSize: '0.95rem' }}
                                rows={this.state.customerTransactions.map((t: any, i: number) => ({ id: t.id ?? i, ...t }))}
                                columns={[
                                    { headerName: 'Id', field: 'id', flex: 0.7, minWidth: 70, resizable: true },
                                    { headerName: 'Title', field: 'title', flex: 1.4, minWidth: 140, resizable: true },
                                    { headerName: 'Amount', field: 'amount', type: 'number', flex: 0.8, minWidth: 90, resizable: true },
                                    { headerName: 'Status', field: 'status', flex: 0.9, minWidth: 90, resizable: true },
                                    { headerName: 'Updated At', field: 'updated_at', flex: 1.2, minWidth: 150, resizable: true },
                                ]}
                                pageSize={6}
                                rowsPerPageOptions={[6]}
                            />
                        </Grid>
                    }
                    {this.state.activeTable === 'tickets' &&
                        <Grid item md={12} xs={12} textAlign="left">
                            <DataGrid
                                autoHeight
                                density="compact"
                                rowHeight={46}
                                headerHeight={42}
                                disableSelectionOnClick
                                sx={{ fontSize: '0.95rem' }}
                                rows={this.state.customerTickets.map((t: any, i: number) => ({ id: t.id ?? i, ...t }))}
                                columns={[
                                    { headerName: 'Id', field: 'id', flex: 0.7, minWidth: 70, resizable: true },
                                    { headerName: 'Type', field: 'type', flex: 1, minWidth: 110, resizable: true },
                                    {
                                        headerName: 'Status', field: 'status', flex: 0.9, minWidth: 100, resizable: true, renderCell: (params: any) => (
                                            <Typography className={params.row.status === 'closed' ? 'statusTextSuccess' : params.row.status === 'inProgress' ? 'statusTextWarning' : params.row.status === 'responded' ? 'statusTextInfo' : 'statusTextError'} component="span">
                                                {params.row.status === 'closed' ? 'Closed' : params.row.status === 'inProgress' ? 'In Progress' : params.row.status === 'responded' ? 'Responded' : 'Open'}
                                            </Typography>
                                        )
                                    },
                                    { headerName: 'Query', field: 'ticket_query', flex: 1.6, minWidth: 160, resizable: true, sortable: false, valueGetter: (params: any) => params.row?.ticket_query?.message || '-' },
                                    { headerName: 'Created At', field: 'created_at', flex: 1.2, minWidth: 150, resizable: true },
                                ]}
                                pageSize={6}
                                rowsPerPageOptions={[6]}
                            />
                        </Grid>
                    }
                </Grid>
            }
        </Box>
    );

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const maskedValueSx = isUatEnvironment
            ? {
                filter: 'blur(4px)',
                opacity: 0.5,
                userSelect: 'none',
            }
            : undefined;
        const renderMaskedValue = (value: React.ReactNode) => (
            <Box component="span" sx={maskedValueSx}>
                {value}
            </Box>
        );


        const handleCloseTicket = () => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "ticket_id": this.state.ticket_id
            }
            axios.post('closeAticket', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("data", response.data.data); 
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchTicketDetails();
                } else {
                    // console.log("err");
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleOpenTicket = () => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "ticket_id": this.state.ticket_id
            }
            axios.post('reOpenTicket', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("resp", response.data.data);
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchTicketDetails();
                } else {
                    // console.log("err");
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const prepareFiles = (event: any) => {
            let files = event.target.files;
            if (files.length > 2) {
                toast.error(t("OnlyTwoImagesAllowed"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.setState({ files: null });
                event.target.value = null;
            }
            if (files.length > 0) {
                this.setState({ files: files });
            } else {
                this.setState({ files: null });
            }
        }

        const fetchPausePickupHistory = () => {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds };
            axios.get('getCustomerDetails/' + this.state.ticket_details?.user?.id, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let customerDetails = response.data.data;
                // console.log("details", customerDetails);
                this.setState({
                    pausePickupData: [...customerDetails.unavailability]
                })
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            })
        }

        const isImage = (image: string) => {
            let extension = image.split(/[. ]+/).pop();
            return (extension != 'pdf') ? true : false;
        }

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: "Start Date",
                field: "start_date",
                width: 250
            },
            {
                headerName: "End Date",
                field: "end_date",
                width: 120
            },
        ]

        const handleCloseEditModal = () => {
            this.setState({ showEditModal: false });
        };

        const bagDistribution = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "agent_id": this.state.allotedAgents,
                "bag_count": this.state.bagCount,
                "community_id": this.state.ticket_details?.user?.community?.community_id,
                "distribution_type": this.state.distributionType,
                "date": formatDate(this.state.date, 'Y-m-d'),
                "users": [this.state.ticket_details?.user_id],
                "overrideMinimumBagsRecevied": this.state.overrideMinimumBagsReceived,
            }
            axios.post('bagDistribution', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("response", response.data.data);
                    this.setState({ showBagDistribution: false, showLoader: false, date: '', distributionType: '', bagCount: 6, allotedAgents: '' });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    // this.fetchCommunityUsers();
                } else {
                    this.setState({ showBagDistribution: false, showLoader: false, date: '', distributionType: '', bagCount: 6, allotedAgents: '' });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showBagDistribution: false, showLoader: false, date: '', distributionType: '', bagCount: 6, allotedAgents: '' });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }



        console.log("here is the message", this.state.selectedMessage)

        return (
            <div>
                <IconButton
                    aria-label={this.state.atBottom ? 'jump to top' : 'jump to bottom'}
                    onClick={() => window.scrollTo({ top: this.state.atBottom ? 0 : document.body.scrollHeight, behavior: 'smooth' })}
                    sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1200, bgcolor: 'primary.main', color: '#fff', boxShadow: 3, '&:hover': { bgcolor: 'primary.dark' } }}
                >
                    {this.state.atBottom ? <KeyboardDoubleArrowUpRounded /> : <KeyboardDoubleArrowDownRounded />}
                </IconButton>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={false}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover={false}
                />
                <NeighbourhoodHeader user={this.props.user} />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                // avatar={
                                //     <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/neighbourhood/tickets'}><KeyboardArrowLeftRounded /></Button>
                                // }
                                avatar={
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        className="customBackButton"
                                        onClick={() => {
                                            if (this.props.history.length > 1) {
                                                this.props.history.goBack();
                                            } else {
                                                this.props.history.push('/neighbourhood/tickets');
                                            }
                                        }}
                                    >
                                        <KeyboardArrowLeftRounded />
                                    </Button>
                                }

                                title="Ticket Details"
                                className="text-left"
                                action={
                                    <>
                                        {
                                            ['purchase new bags', 'regular bag request'].includes(this.state.ticket_details?.type?.toLowerCase()) &&
                                            <Button size="small" variant='contained' className='mr-2' onClick={() => this.setState({ showBagDistributionModal: true, bagCount: 6 })}>
                                                New Bag Distribution
                                            </Button>
                                        }
                                        <Button size="small" variant='contained' className='mr-2' onClick={() => {
                                            this.setState({ showPausePickupHistoryModal: true });
                                            fetchPausePickupHistory()
                                        }}>Pause Pickup History</Button>
                                        {
                                            this.state.ticket_details.status == 'closed' ? <Button size="small" variant='contained' onClick={() => handleOpenTicket()}>Re-Open Ticket</Button> : <Button size="small" variant='contained' color='error' onClick={() => handleCloseTicket()}>Close Ticket</Button>
                                        }
                                    </>
                                }
                            />
                            <CardContent sx={{ display: 'flex' }} className='overview'>
                                <Grid container spacing={2}>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Ticket Id
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            #{this.state.ticket_details?.id}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Type
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {this.state.ticket_details?.type}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Status
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {this.state.ticket_details?.status}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Customer Name
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            <Link to={`/neighbourhood/customers/${this.state.ticket_details?.user?.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                {renderMaskedValue(this.state.ticket_details?.user?.name)}
                                            </Link>
                                        </Typography>
                                    </Grid>

                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Mobile
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            <Link to={`/neighbourhood/customers/${this.state.ticket_details?.user?.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                {renderMaskedValue(this.state.ticket_details?.user?.phone)}
                                            </Link>
                                        </Typography>
                                    </Grid>

                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Community/H.No
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {renderMaskedValue(
                                                <>
                                                    {this.state.ticket_details?.user?.community?.info.name}/{this.state.ticket_details?.user?.customer?.location}
                                                </>
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Pickup Date
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {this.state.ticket_details?.pickup_date}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="subtitle1" component="div" className='overviewTitle'>
                                            Next Bag Distribution Date
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {this.state.ticket_details?.next_bag_distribution_date}
                                        </Typography>
                                    </Grid>
                                    {/* <Grid item md={3} xs={3} textAlign='left'>
                                        <Typography variant="body1" component="div" className='overviewTitle'>
                                            Agent
                                        </Typography>
                                        <Typography variant="body1" component="div" className='overviewValue'>
                                            {this.state.ticket_details?.agent}
                                        </Typography>
                                    </Grid> */}
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <div style={{ position: 'relative' }}>
                    {this.state.ticket_details?.ticket_summary &&
                        <Grid container className="mt-3" style={{ position: 'sticky', top: '90px', zIndex: 2 }}>
                            <Grid item md={12} xs={12}>
                                <Card>
                                    <CardContent sx={{ '&:last-child': { pb: 2 }, textAlign: 'left' }}>
                                        <Box component="details" {...{ open: true } as any} sx={{
                                            '& > summary': { cursor: 'pointer', listStyle: 'none', display: 'flex', alignItems: 'center', fontWeight: 700, fontSize: '1.05rem', mb: 1.5 },
                                            '& > summary::-webkit-details-marker': { display: 'none' },
                                            '& > summary::before': { content: '"\\25B8"', mr: '8px', fontSize: '1.3rem', fontWeight: 700, color: 'text.secondary' },
                                            '&[open] > summary::before': { content: '"\\25BE"' },
                                        }}>
                                            <Box component="summary">Ticket Summary</Box>
                                            {this.renderTicketSummary(this.state.ticket_details.ticket_summary)}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    }
                    {this.state.showPickupBags &&
                        <Modal open={this.state.showPickupBags} onClose={() => this.setState({ showPickupBags: false })} aria-labelledby="pickup-bags-modal">
                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', boxShadow: 24, p: 3, borderRadius: 2 }}>
                                <Typography variant="h6" gutterBottom>
                                    Bag Details — Pickup #{this.state.selectedPickup?.id} ({this.state.selectedPickup?.pickup_date})
                                </Typography>
                                {this.state.pickupBagsLoading ?
                                    <Grid container justifyContent="center" className="p-3"><CircularProgress /></Grid>
                                    :
                                    <DataGrid
                                        autoHeight
                                        density="compact"
                                        rows={this.state.pickupBags.map((b: any, i: number) => ({ id: b.id ?? i, ...b }))}
                                        columns={[
                                            { headerName: 'Id', field: 'id', width: 80 },
                                            { headerName: 'UID', field: 'uid', width: 130 },
                                            { headerName: 'Weight', field: 'weight', width: 90 },
                                            { headerName: 'Added', field: 'created_at', width: 170 },
                                        ]}
                                        pageSize={10}
                                        rowsPerPageOptions={[10]}
                                        sx={{ maxHeight: 400 }}
                                    />
                                }
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button size="small" className="customCloseButton" onClick={() => this.setState({ showPickupBags: false })}>Close</Button>
                                </Box>
                            </Box>
                        </Modal>
                    }
                    <Grid container className="ticketMessages mt-3">
                        {
                            this.state.ticket_details?.messages?.map((el: any, key: any) => {
                                if (el.user.account_type == 'customer') {
                                    return (
                                        <Grid key={key} container justifyContent={'flex-start'}>
                                            <Grid item md={5} xs={11}>
                                                <Card className='mt-3' sx={{ boxShadow: 3, width: '100%' }}>
                                                    <CardContent>
                                                        <Grid container spacing={2}>
                                                            <Grid item md={6} xs={6} textAlign={'left'}>
                                                                <Typography variant="subtitle1" component="div" className="userName">
                                                                    {el?.user?.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={6} xs={6} textAlign={'right'}>
                                                                <Typography variant='body2' component="div">
                                                                    {el?.created_at}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={12} xs={12} style={{ flex: '1 1 auto', maxWidth: '100%' }} textAlign={'left'}>
                                                                {/* <Typography variant="body1" component="div">
                                                                {el?.message}
                                                            </Typography> */}
                                                                <Typography
                                                                    variant="body1"
                                                                    component="div"
                                                                    dangerouslySetInnerHTML={{ __html: el?.message }}
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap', // This keeps the line breaks and wraps text properly
                                                                        textAlign: 'left', // Aligns text to the left
                                                                        width: '100%', // Ensures the typography takes full width of the card
                                                                    }}
                                                                />
                                                            </Grid>
                                                            {el.image?.map((ele: any, ele_index: number) => (
                                                                <Grid item md={12} xs={12} textAlign={'right'} key={ele_index}>
                                                                    {
                                                                        (isImage(ele)) &&
                                                                        <a href={ele} target='_blank'>
                                                                            <img src={ele} style={{ width: "100%" }} alt="Image" />
                                                                        </a>
                                                                    }
                                                                    {
                                                                        (!isImage(ele)) &&
                                                                        <a href={ele} target='_blank'>
                                                                            <iframe title="PDF Viewer" src={ele} width="100%" height="200" style={{ border: 'none' }} />
                                                                        </a>
                                                                    }
                                                                    {
                                                                        (!isImage(ele)) &&
                                                                        <>
                                                                            <Button variant='contained' size='small' className='link' href={ele} download={true} target='_blank'>Fullscreen</Button>
                                                                        </>
                                                                    }
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    );
                                } else {
                                    return (
                                        <Grid key={key} container justifyContent={'flex-end'}>
                                            <Grid item md={5} xs={11}>
                                                <Card className='mt-3' sx={{ boxShadow: 3, width: '100%' }}>
                                                    <CardContent>
                                                        <Grid container spacing={2}>
                                                            <Grid item md={6} xs={6} textAlign={'left'}>
                                                                <Typography variant='body2' component="div">
                                                                    {el?.created_at}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={6} xs={6} textAlign={'right'}>
                                                                <Typography variant="subtitle1" component="div" className="userName">
                                                                    {el?.user?.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={12} xs={12} textAlign={'right'}>
                                                                {/* <Typography variant="body1" component="div">
                                                                {el?.message}
                                                            </Typography> */}
                                                                <Typography
                                                                    variant="body1"
                                                                    component="div"
                                                                    dangerouslySetInnerHTML={{ __html: el?.message }}
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap', // This keeps the line breaks and wraps text properly
                                                                        textAlign: 'left', // Aligns text to the left
                                                                        width: '100%', // Ensures the typography takes full width of the card
                                                                    }}
                                                                />
                                                            </Grid>
                                                            {el.image?.map((ele: any, ele_index: number) => (
                                                                <Grid item md={12} xs={12} textAlign={'right'} key={ele_index}>
                                                                    {
                                                                        (isImage(ele)) &&
                                                                        <a href={ele} target='_blank'>
                                                                            <img src={ele} style={{ width: "100%" }} alt="Image" />
                                                                        </a>
                                                                    }
                                                                    {
                                                                        (!isImage(ele)) &&
                                                                        <a href={ele} target='_blank'>
                                                                            <iframe title="PDF Viewer" src={ele} width="100%" height="200" style={{ border: 'none' }} />
                                                                        </a>
                                                                    }
                                                                    {
                                                                        (!isImage(ele)) &&
                                                                        <>
                                                                            <Button variant='contained' size='small' className='link' href={ele} download={true} target='_blank'>Fullscreen</Button>
                                                                        </>
                                                                    }
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item md={1} xs={2} textAlign={'center'}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>

                                                    <IconButton
                                                        color="primary"
                                                        aria-label="edit message"
                                                        component="span"
                                                        onClick={() => this.setState({
                                                            showEditModal: true,
                                                            selectedMessage: el,
                                                        })}
                                                    >
                                                        <EditRounded sx={{ verticalAlign: "middle" }} />
                                                    </IconButton>

                                                    <IconButton
                                                        color="error"
                                                        aria-label="delete message"
                                                        component="span"
                                                        onClick={() => this.setState({ showDeleteMessageConfirmationDialog: true, messageToBeDeleted: el })}
                                                    >
                                                        <DeleteRounded sx={{ verticalAlign: "middle" }} />
                                                    </IconButton>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    );
                                }
                            })
                        }
                    </Grid>
                </div>
                <Grid container className="mt-3">
                    <Grid item md={12} xs={12}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={2} alignItems="stretch">
                                    <Grid item md={6} xs={12}>
                                        {this.renderCustomerData()}
                                    </Grid>
                                    {this.state.ticket_details.status != "closed" &&
                                        <Grid item md={6} xs={12} textAlign={'left'} sx={{ pl: { md: 2 } }}>
                                            <form id={"ticket-reply-form"} onSubmit={this.ticketReplyFormSubmission}>
                                                <FormControl fullWidth={true} style={{ marginBottom: '17px', position: 'relative' }}>
                                                    <Grid item md={12} xs={12}>
                                                        <ReactQuill
                                                            theme="snow"
                                                            value={this.state.comment}
                                                            onChange={(comment: any) => {
                                                                this.setState({ comment });
                                                            }}
                                                            modules={{
                                                                toolbar: [
                                                                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                                                                    ['link', 'image', 'video', 'table']
                                                                ]
                                                            }}
                                                            formats={[
                                                                'header', 'font', 'size',
                                                                'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                                'list', 'bullet', 'indent',
                                                                'link', 'image', 'video', 'table'
                                                            ]}
                                                        />
                                                    </Grid>

                                                </FormControl>
                                                <FormControl fullWidth={true} style={{ marginBottom: '17px', position: 'relative' }}>
                                                    <TextField id="outlined-basic" type={'file'} label="File" InputLabelProps={{ shrink: true }} onChange={(event: any) => prepareFiles(event)} inputProps={{ multiple: true, filename: this.state.files }} InputProps={{ inputProps: { accept: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'].join(',') } }} />
                                                </FormControl>
                                                <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                                                    <Button
                                                        type="button"
                                                        variant="outlined"
                                                        color="primary"
                                                        size="large"
                                                        style={{ flex: 1 }}
                                                        disabled={!this.state.comment || this.state.aiDraftLoading}
                                                        onClick={this.fetchAIDraft}
                                                    >
                                                        {this.state.aiDraftLoading ? 'Generating...' : '✦ Refine with AI'}
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        variant="outlined"
                                                        color="primary"
                                                        size="large"
                                                        title="Undo AI refinement"
                                                        startIcon={<UndoRounded />}
                                                        style={{ flex: '0 0 110px', minWidth: 0 }}
                                                        disabled={!this.state.aiDraftHistory.length || this.state.aiDraftLoading}
                                                        onClick={this.undoAIDraft}
                                                    >
                                                        Undo
                                                    </Button>
                                                </div>
                                                <Button type="submit" variant="contained" color="primary" size='large' fullWidth={true} disabled={!this.state.comment}>
                                                    Post Comment
                                                </Button>
                                            </form>
                                        </Grid>
                                    }
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showDeleteMessageConfirmationDialog}
                    onClose={() => this.setState({ showDeleteMessageConfirmationDialog: false, messageToBeDeleted: null })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Are you sure you want to delete this message?"}
                    </DialogTitle>
                    <DialogActions>
                        <Button size='small' className='customCloseButton' onClick={() => this.setState({ showDeleteMessageConfirmationDialog: false, messageToBeDeleted: null })}>Close</Button>
                        <Button size='small' variant='contained' color='error' sx={{ outline: 'none !important' }} onClick={() => this.handleDeleteMessage()} autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                <Modal
                    open={this.state.showPausePickupHistoryModal}
                    onClose={() => this.setState({ showPausePickupHistoryModal: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={"Pause Pickup History"}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showPausePickupHistoryModal: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <DataGrid
                                    aria-label="Pause Pickup History"
                                    columns={columns}
                                    rows={this.state.pausePickupData}
                                    // rowCount={this.state.rowCount}
                                    // pageSize={this.state.pageSize}
                                    // onPageChange={(page) => this.fetchNeighbourhood(page)}
                                    // onPageSizeChange={(newPageSize) => {this.setState({ pageSize: newPageSize }); this.fetchNeighbourhood(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    // style={{height: 500}}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                // className="clickableList"
                                // paginationMode="server"
                                />
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showPausePickupHistoryModal: false })}>Close</Button>
                                {/* <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => createBulkUsers()}>Create Users</Button> */}
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal open={this.state.showEditModal} onClose={handleCloseEditModal}>
                    <Box sx={style}>
                        <Card>
                            <CardContent>
                                <Grid container justifyContent={'center'}>
                                    <Grid item md={12} xs={12}>
                                        <form id={"ticket-reply-form"} onSubmit={this.updateComment}>
                                            <FormControl fullWidth style={{ marginBottom: '17px', position: 'relative' }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={this.state.selectedMessage?.message}
                                                    onChange={(comment: any) =>
                                                        this.setState((prevState) => ({
                                                            selectedMessage: {
                                                                ...prevState.selectedMessage,
                                                                message: comment, // Update the message directly
                                                            }
                                                        }))
                                                    }
                                                    modules={{
                                                        toolbar: [
                                                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                                                            ['link', 'image', 'video', 'table']
                                                        ]
                                                    }}
                                                    formats={[
                                                        'header', 'font', 'size',
                                                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                        'list', 'bullet', 'indent',
                                                        'link', 'image', 'video', 'table'
                                                    ]}
                                                />
                                            </FormControl>
                                            <Button type="submit" variant="contained" color="primary" size="large" fullWidth disabled={!this.state.selectedMessage?.message}>
                                                Update Comment
                                            </Button>
                                            <Button onClick={handleCloseEditModal}
                                                color="inherit"
                                                fullWidth style={{ marginTop: '10px' }}>
                                                Cancel
                                            </Button>
                                        </form>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showBagDistributionModal}
                    onClose={() => this.setState({ showBagDistributionModal: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{
                        position: 'absolute' as 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '65%',
                        p: 4,
                    }}>
                        <Card>
                            <CardHeader
                                title="New Bag Distribution"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showBagDistributionModal: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat='yyyy-MM-dd'
                                                    views={['year', 'month', 'day']}
                                                    mask='____-__-__'
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label="Date"
                                                    disablePast
                                                    value={this.state.date}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ date: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">Distribution Type</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.distributionType}
                                                onChange={(e) => this.setState({ distributionType: e.target.value })}
                                                displayEmpty
                                                label="Distribution Type"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={"regular"}>Regular</MenuItem>
                                                <MenuItem key={2} value={"ondemand"}>On Demand</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            id="agent-name-input"
                                            label="Bags"
                                            value={this.state.bagCount}
                                            onChange={(e: any) => this.setState({ bagCount: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">Agents</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.allotedAgents}
                                                onChange={(e) => this.setState({ allotedAgents: e.target.value })}
                                                displayEmpty
                                                label="Agents"
                                                fullWidth={true}
                                            >
                                                {/* <MenuItem key={1} value={1}>Regular</MenuItem>
                                                                <MenuItem key={2} value={2}>On Demand</MenuItem> */}
                                                {
                                                    this.state.agents?.map((el: any) => {
                                                        return (
                                                            <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <br />
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={this.state.overrideMinimumBagsReceived} onClick={() => this.setState({ overrideMinimumBagsReceived: !this.state.overrideMinimumBagsReceived })} />} label={<Typography>Override requirement for <b>"At least one pickup completed in last 4 weeks"</b></Typography>} />
                                </FormGroup>
                                <br />
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showBagDistributionModal: false })}>Close</Button>
                                <Button size='small' variant='contained' onClick={() => bagDistribution()}>Confirm Distribution</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(TicketDetails))
